export default __webpack_public_path__ + "static/help_06_03-4-5770587bb3b6f57b21da50a4b8a23e7d.png";